module.exports = __webpack_public_path__ + "static/media/figado-icon.e966caa3.png";